// packages import
import { Box } from "@mui/material";
import { SyntheticEvent, useContext, useState } from "react";
import { useParams } from "react-router-dom";
// component import
import { Alert } from "../common/Alert";
import { DetailPageHeader } from "../layout/DetailPageHeader";
import { CasesAgainstCourtListing } from "./CasesAgainstCourtListing";
import { JudgeListing } from "./judge/JudgeListing";
// others
import { useFetchCourtQuery } from "../../../generated";
import { AppContext } from '../../context/AppContext';
import { ActionType } from "../../context/AppContextReducer";
import { TabItem, TabsContainer } from "../../theme/styleComponents";
import { capitalizeCase } from "../../utils";
import { a11yProps, TabPanel } from "../common/TabPanel";


export const CourtDetail = () => {
  const [courtName, setCourtName] = useState<string>("")
  const { dispatch } = useContext(AppContext)
  const [value, setValue] = useState<number>(0);
  const { id: courtId } = useParams()

  const { loading } = useFetchCourtQuery({
    variables: {
      courtInput: {
        id: courtId || ''
      }
    },

    onError() {
      Alert.error("Court is not fetched, something went wrong!")
    },

    onCompleted(data) {
      if (data) {
        const { fetchCourt } = data

        if (fetchCourt) {
          const { court, response } = fetchCourt
          const { status } = response || {}

          if (status === 200 && court) {
            setCourtName(court.name)
          }
        }
      }
    }
  })

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setValue(newValue)
    dispatch({ type: ActionType.SET_CURRENT_PAGE, currentPage: 1 })
  }

  return (
    <Box>
      <DetailPageHeader title={capitalizeCase(courtName || '')} loading={loading} />

      <TabsContainer value={value} onChange={handleChange} aria-label="user tab"
        TabIndicatorProps={{ sx: { background: 'darkRed' } }}
        sx={{ paddingBlock: '20px' }}
      >
        <TabItem label="Assigned Cases" {...a11yProps(0, 'user')} iconPosition="start" />

        <TabItem label="Judges" {...a11yProps(1, 'user')} iconPosition="start" />
      </TabsContainer>

      <TabPanel value={value} index={0}>
        <CasesAgainstCourtListing courtId={courtId || ""} />
      </TabPanel>

      <TabPanel value={value} index={1}>
        <JudgeListing courtId={courtId!} courtName={courtName} />
      </TabPanel>
    </Box>
  )
}